import { z } from 'zod'

export const createRoomSchema = z.object({
  bookId: z.string().min(1, 'Book is required'),
  name: z.string().min(1, 'Name is required').max(200, 'Name must be 200 characters or less'),
  startDate: z.string().datetime('Invalid start date'),
  endDate: z.string().datetime('Invalid end date'),
  maxMembers: z.number().int().positive().optional(),
})

export const updateRoomSchema = z.object({
  name: z.string().min(1, 'Name is required').max(200, 'Name must be 200 characters or less').optional(),
  currentSegment: z.number().int().positive().optional(),
  status: z.enum(['UPCOMING', 'ACTIVE', 'COMPLETED', 'ARCHIVED']).optional(),
  archiveSentiment: z.string().max(2000, 'Sentiment must be 2000 characters or less').optional(),
})

export type CreateRoomInput = z.infer<typeof createRoomSchema>
export type UpdateRoomInput = z.infer<typeof updateRoomSchema>
